import React, {useEffect, useState} from 'react';
import {Card, Layout, Select, Spin, Typography,} from 'antd';

import StudentLayout from "@/components/layout/student/studentLayout";


import {useSearchParams} from "react-router-dom";

import {URLS} from "@/lib/urls";

import LocationPermissionGuide from "@/pages/student/lessons/take/_section/LocationPermissionGuid";
import IranMap from "@/components/map/Map";
import {useApiSearchStudentClassroomForMap} from "@/api/classroom";

import StudentMapPopup from "@/pages/student/lessons/take/_section/StudentMapPopup";

const {Header, Content, Sider} = Layout;
const {Title, Text} = Typography;
const {Option} = Select;
const {Meta} = Card;


export default function StudentLessonMapPage() {


    const [loading, setLoading] = useState(false)

    const [searchParams, setSearchParams] = useSearchParams();

    const [myPoints, setMyPoints] = useState([])
    const [allowLocation, setAllowLocation] = useState(false)
    const [itemClicked, setItemClicked] = useState({})
    const {data: classroomList, isPending: isPendingClassroom} = useApiSearchStudentClassroomForMap({
        grade_id: searchParams.get("grade_id"),
    })

    useEffect(() => {
        if (classroomList?.data?.data?.length > 0) {
            classroomList?.data?.data?.map(item => {
                setMyPoints(classroomList?.data?.data)
            })
        }
    }, [classroomList]);

    const icon = loading ? <Spin size="small"/> : <i className={`icon-magnifying-glass`}></i>

    return (
        <>


            <StudentLayout pageTitle={'انتخاب مجل برگزاری کلاس'}
                           backTo={URLS.student.lessons.take + '?' + searchParams.toString()}>

                <LocationPermissionGuide setAllowLocation={setAllowLocation}/>
                <div className={'flex'}>


                    <div className={'m-1 w-full'}>
                        <div className={' rounded-xl p-2'}>
                            <div className={'my-2'}>با توجه به موقعیت خودتان نزدیک ترین کلاس را به محل زندگی انتخاب
                                کنید
                            </div>
                            <div className="h-[600px]">
                                <IranMap
                                    points={myPoints}
                                    clickHandler={false}
                                    myLocationDetector={true}
                                    setItemClicked={setItemClicked}
                                    popupElement={<StudentMapPopup/>}
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </StudentLayout>


        </>

    );
}